import { useContext, useEffect, useState } from "react";
import DefaultCallerIdView from "./view";
import { toast } from "react-toastify";
import { AppContext } from "@client/shared/contexts";
import { VALIDATIONS } from "@client/shared/constants";
import { validate as validator } from "@client/utils";

import Service from "./service";
let hasValueChanged = false;
const defaultState = {
  defaultCallerIdName: "",
  defaultCallerIdNumber: "",
  errors: {
    defaultCallerIdName: " ",
    defaultCallerIdNumber: " ",
  },
  isLoading: false,
};
const DefaultCallerId = () => {
  const [state, setState] = useState(defaultState);
  const { appData, setAppData } = useContext(AppContext);
  const validateFields = (field, value, fieldValidator) => {
    let errorMessage = "";
    let fieldValidatorMap = fieldValidator || {
      defaultCallerIdName: [
        { type: VALIDATIONS.REGEX, value: /^[a-zA-Z0-9\s#]*$/ },
        { type: VALIDATIONS.MAX_LENGTH, value: 100 },
        { type: VALIDATIONS.REQUIRED, value: true },
      ],
      defaultCallerIdNumber: [{ type: VALIDATIONS.REQUIRED, value: true }],
    };

    if (fieldValidatorMap[field]) {
      const validationResult = fieldValidatorMap[field].map((validation) =>
        validator(
          value,
          validation.type,
          validation.value,
          validation.inputType || "string"
        )
      );
      errorMessage = validationResult
        .filter((error) => !error?.isValid)
        .map((error) => error?.errorMessage)[0];
    } else {
      Object.keys(fieldValidatorMap).forEach((key) => {
        const message = validateFields(key, state[key], fieldValidatorMap);
        if (!!message) {
          errorMessage = message;
        }
      });
    }
    return errorMessage;
  };

  const handleChange = (event) => {
    const { name, value } = event.currentTarget;
    hasValueChanged = true;

    // TODO: Refactor
    let errorMessageName =
      validateFields(
        "defaultCallerIdName",
        name === "defaultCallerIdName" ? value : state.defaultCallerIdName
      ) || " ";
    let errorMessageNumber =
      validateFields(
        "defaultCallerIdNumber",
        name === "defaultCallerIdNumber" ? value : state.defaultCallerIdNumber
      ) || " ";

    if (
      name === "defaultCallerIdName" &&
      !value &&
      !state.defaultCallerIdNumber?.id
    ) {
      errorMessageName = " ";
      errorMessageNumber = " ";
    } else if (
      name === "defaultCallerIdNumber" &&
      !value &&
      !state.defaultCallerIdName
    ) {
      errorMessageName = " ";
      errorMessageNumber = " ";
    }
    //

    setState((prevState) => ({
      ...prevState,
      [name]: value,
      errors: {
        ...prevState.errors,
        defaultCallerIdName: errorMessageName,
        defaultCallerIdNumber: errorMessageNumber,
      },
    }));
  };
  const handleSubmit = async () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    const defaultCallerIdName = (state.defaultCallerIdName || "").trim();
    const payload = {
      default_caller_id_name: defaultCallerIdName,
      default_caller_id_number: state.defaultCallerIdNumber?.phoneNumber,
    };
    const { error } = await Service.patch(payload);
    if (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
      return toast.error(
        Array.isArray(error) ? error[0].message : error.message
      );
    }
    toast.success("Default Caller Id Saved Successfully");
    setAppData("defaultCallerId", {
      default_caller_id_name: defaultCallerIdName,
      default_caller_id_number: state.defaultCallerIdNumber?.phoneNumber,
    });
    setState((prevState) => ({
      ...prevState,
      isLoading: false,
    }));
    hasValueChanged = false;
  };
  useEffect(() => {
    return () => {
      hasValueChanged = false;
    };
  }, []);
  useEffect(() => {
    if (
      appData?.defaultCallerId?.default_caller_id_name &&
      appData?.defaultCallerId?.default_caller_id_number
    ) {
      setState((prevState) => ({
        ...prevState,
        defaultCallerIdName: appData?.defaultCallerId?.default_caller_id_name,
        defaultCallerIdNumber:
          (appData.phoneNumberList || []).find(
            (item) =>
              item.phoneNumber ===
              appData?.defaultCallerId?.default_caller_id_number
          ) || {},
      }));
    }
  }, [appData?.defaultCallerId, appData.phoneNumberList]);
  return (
    <>
      <DefaultCallerIdView
        defaultCallerIdName={state.defaultCallerIdName}
        defaultCallerIdNumber={state.defaultCallerIdNumber}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        errors={state.errors}
        isFormValid={
          (validateFields() || !hasValueChanged) &&
          !(!state.defaultCallerIdName && !state.defaultCallerIdNumber)
        }
        phoneNumberList={(appData.phoneNumberList || [])}
      />
    </>
  );
};

export default DefaultCallerId;
